import { Injectable } from '@angular/core';
import { Client, IMessage } from '@stomp/stompjs';
import SockJS from 'sockjs-client'; 
import { HttpClient } from '@angular/common/http'; // N'oublie pas l'import

import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface NotificationDTO {
  id: number;
  creationTime: string;  // Ajoutez un champ pour l'heure de création
  message: string;
  read:boolean;
  userId:number;
}

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private stompClient: Client;
  private notifications: NotificationDTO[] = [];
  private notificationSubject = new BehaviorSubject<NotificationDTO[]>([]);

  public notification$: Observable<NotificationDTO[]> = this.notificationSubject.asObservable();

  constructor(private http: HttpClient) {
    this.stompClient = new Client({
      webSocketFactory: () => new SockJS(`${environment.base_url}/ws-notifications`),
      reconnectDelay: 5000,
      debug: (str) => console.log('STOMP debug:', str),
      onConnect: () => {
        console.log('Connecté au WebSocket !');
        this.stompClient.subscribe('/topic/notifications', (message: IMessage) => {
        const notif: NotificationDTO = JSON.parse(message.body);
        console.log('Notification reçue :', notif);

  this.notifications.unshift(notif);
  this.notificationSubject.next(this.notifications);
});

        
      },
      onStompError: (frame) => {
        console.error('Erreur STOMP : ', frame);
      },
    });

    this.stompClient.activate();
  }


  loadInitialNotifications() {
    this.http.get<NotificationDTO[]>(`${environment.base_url}/api/notifications`)
      .subscribe((notifs) => {
        console.log('Notifications chargées depuis la base de données :', notifs);
        this.notifications = notifs;
        this.notificationSubject.next(this.notifications);
      });
  }

  clearNotificationsBackend() {
    this.http.delete(`${environment.base_url}/api/notifications`).subscribe(() => {
      this.notifications = [];
      this.notificationSubject.next(this.notifications);
      console.log("Notifications supprimées côté backend !");
    });
  }
  
  deleteNotification(id: number): Observable<void> {
    return this.http.delete<void>(`${environment.base_url}/api/notifications/${id}`);
  }
  markAllAsReadForUser(userId: number): Observable<any> {
    return this.http.put<any>(`${environment.base_url}/api/notifications/user/${userId}/mark-all-read`, {});
  }
  
  markAsRead(notificationId: number): Observable<any> {
    return this.http.put(`${environment.base_url}/api/notifications/${notificationId}/read`,null,{ responseType: 'text' });
  }
  
  getNotificationsFromDB(userId: number): Observable<NotificationDTO[]> {
    console.log('Chargement des notifications pour l\'utilisateur avec ID:', userId);
    return this.http.get<NotificationDTO[]>(`${environment.base_url}/api/notifications/notifications?userId=${userId}`);
  }
  
  loadNotificationsForUser(userId: number): void {
    console.log('Chargement des notifications pour l\'utilisateur avec ID:', userId);
    this.http.get<NotificationDTO[]>(`${environment.base_url}/api/notifications?userId=${userId}`)
      .subscribe(notifications => {
        console.log('Notifications récupérées pour l\'utilisateur:', notifications);
        this.notificationSubject.next(notifications);
      }, error => {
        console.error('Erreur lors du chargement des notifications:', error);
      });
  }

}  

